import {
  GET_LIST_DUNONHANVAY,
  GET_LIST_DUNONHANVAY_SUCCESS,
  GET_LIST_DUNONHANVAY_FAILURE,
  UPDATE_SEARCHTDATA_DUNONHANVAY,
} from "./actionTypes";

export const getListDuNoNhanVay = (dataSearch) => ({
  type: GET_LIST_DUNONHANVAY,
  dataSearch,
});
export const getListDuNoNhanVaySuccess = (data) => ({
  type: GET_LIST_DUNONHANVAY_SUCCESS,
  payload: data,
});
export const getListDuNoNhanVayFailure = (dataSearch) => ({
  type: GET_LIST_DUNONHANVAY_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_DUNONHANVAY,
  payload: data,
});
